import { render, staticRenderFns } from "./StaticPix.vue?vue&type=template&id=d7f874f2"
import script from "./StaticPix.vue?vue&type=script&lang=js"
export * from "./StaticPix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports